import { useAuthStore } from '@/stores/auth';

export function setupPageAccessGuard(router) {
  router.beforeEach(async (to, from, next) => {
    
    // Skip checking for login/auth pages or other public pages
    if (to.meta.skipAccessCheck || to.meta.public) {
      return next();
    }

    const authStore = useAuthStore();
    
    // If not authenticated, redirect to login
    if (!authStore.isAuthenticated) {
      return next('/login');
    }

    try {
      // Refresh user pages before navigation
      await authStore.fetchUserPages();
      
      // Extract all nome_fisico values from the matched routes
      // Skip dashboard which everyone should have access to
      const requiredPermissions = to.matched
        .filter(record => record.meta.nome_fisico && record.meta.nome_fisico !== 'dashboard')
        .map(record => record.meta.nome_fisico);
      
      if (requiredPermissions.length > 0) {
        const userPages = authStore.user?.paginas || [];
        const userPageNames = userPages.map(page => page.nome_fisico);
        
        const hasAccess = requiredPermissions.every(permission => 
          userPageNames.includes(permission)
        );
        
        if (!hasAccess) {
          return next('/sem-autorizacao');
        }
      }
      
      next();
    } catch (error) {
      next('/sem-autorizacao');
    }
  });
}
